(() => {
  if (customElements.get("mb-announcement")) return;

  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll("[data-announcement-slide]")];
      if (this.slides.length < 2) return;

      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains("is-active")),
      );
      this.previousButton = this.querySelector("[data-announcement-previous]");
      this.nextButton = this.querySelector("[data-announcement-next]");
      this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.onPrevious = () => this.show(this.index - 1);
      this.onNext = () => this.show(this.index + 1);
      this.onPause = () => this.stop();
      this.onResume = () => this.start();
      this.onVisibilityChange = () => (document.hidden ? this.stop() : this.start());
      this.onMotionChange = () => (this.reducedMotion.matches ? this.stop() : this.start());

      this.previousButton.addEventListener("click", this.onPrevious);
      this.nextButton.addEventListener("click", this.onNext);
      this.addEventListener("mouseenter", this.onPause);
      this.addEventListener("mouseleave", this.onResume);
      this.addEventListener("focusin", this.onPause);
      this.addEventListener("focusout", this.onResume);
      document.addEventListener("visibilitychange", this.onVisibilityChange);
      this.reducedMotion.addEventListener("change", this.onMotionChange);
      this.classList.add("is-ready");
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (this.slides?.length < 2) return;

      this.previousButton.removeEventListener("click", this.onPrevious);
      this.nextButton.removeEventListener("click", this.onNext);
      this.removeEventListener("mouseenter", this.onPause);
      this.removeEventListener("mouseleave", this.onResume);
      this.removeEventListener("focusin", this.onPause);
      this.removeEventListener("focusout", this.onResume);
      document.removeEventListener("visibilitychange", this.onVisibilityChange);
      this.reducedMotion.removeEventListener("change", this.onMotionChange);
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.classList.toggle("is-active", active);
        slide.toggleAttribute("inert", !active);
        if (active) slide.removeAttribute("aria-hidden");
        else slide.setAttribute("aria-hidden", "true");
      });
      this.stop();
      this.start();
    }

    start() {
      if (
        this.timer ||
        this.reducedMotion.matches ||
        document.hidden ||
        this.matches(":hover") ||
        this.contains(document.activeElement)
      )
        return;
      this.timer = window.setInterval(() => this.show(this.index + 1), 6000);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define("mb-announcement", AnnouncementBar);
})();
